// src/themes/theme/theme2.js
import { ThemeMode } from 'config';

// Palette khusus berdasarkan warna yang kamu berikan:
// #00008B #485D9A #9CCBF9 #EDF3FC
// #4C00A4 #7309B8 #0072DA (gradient: #9CCBF9 -> #EDF3FC)
// #FF0000 #01FF05 #FCB859

export default function Theme2(colors, mode) {
  const { grey } = colors;
  const greyColors = {
    0: grey[0],
    50: grey[1],
    100: grey[2],
    200: grey[3],
    300: grey[4],
    400: grey[5],
    500: grey[6],
    600: grey[7],
    700: grey[8],
    800: grey[9],
    900: grey[10],
    A50: grey[15],
    A100: grey[11],
    A200: grey[12],
    A400: grey[13],
    A700: grey[14],
    A800: grey[16]
  };

  const contrastText = '#fff';

  // Susunan 10-step untuk primary (dari paling terang -> paling gelap)
  let primaryColors = [
    '#EDF3FC', // lighter
    '#DDECFB',
    '#9CCBF9', // light
    '#73B8F1',
    '#4F90E0',
    '#485D9A', // main (ungu mid)
    '#7309B8', // dark accent
    '#4C00A4', // darker purple
    '#0072DA', // accent blue
    '#00008B' // darkest navy
  ];

  const PRIMARY_GRADIENT = 'linear-gradient(180deg, #9CCBF9 0%, #EDF3FC 100%)';

  const DRAWER_GRADIENT = 'linear-gradient(180deg, #485D9A 0%, #9CCBF9 100%)';

  // status colors sesuai palette
  let errorColors = ['#FFECEC', '#FFB3B3', '#FF0000', '#E60000', '#B80000'];
  let warningColors = ['#FFF7E0', '#FFD9A8', '#FCB859', '#F4A43A', '#D08528'];
  let infoColors = ['#EAF6FF', '#CFEFFF', '#0072DA', '#005BB0', '#003F73'];
  let successColors = ['#E8FFE9', '#9FFFAF', '#01FF05', '#00C93E', '#008D3A'];

  // versi gelap (opsional) — gunakan variasi lebih gelap
  if (mode === ThemeMode.DARK) {
    primaryColors = ['#000A1A', '#001A3A', '#002A5A', '#003F73', '#1E2B5F', '#485D9A', '#4C00A4', '#5F53DF', '#0072DA', '#00008B'];
    // status untuk dark mode (sederhana)
    errorColors = ['#2b1010', '#7a1f1f', '#ff4d4d', '#e63939', '#b82b2b'];
    warningColors = ['#2b220f', '#7a5a1e', '#fcaf40', '#e08a1f', '#b86f12'];
    infoColors = ['#071523', '#0a3a57', '#0068a8', '#0a88b0', '#4db6c8'];
    successColors = ['#082115', '#0f6b2f', '#01ff05', '#0fa95d', '#0c7b3d'];
  }

  return {
    primary: {
      lighter: primaryColors[0],
      100: primaryColors[1],
      200: primaryColors[2],
      light: primaryColors[3],
      400: primaryColors[4],
      main: primaryColors[5],
      dark: primaryColors[6],
      700: primaryColors[7],
      darker: primaryColors[8],
      900: primaryColors[9],
      contrastText,
      gradient: PRIMARY_GRADIENT,
      drawerGradient: DRAWER_GRADIENT
    },
    secondary: {
      lighter: greyColors[100],
      100: greyColors[100],
      200: greyColors[200],
      light: greyColors[300],
      400: greyColors[400],
      main: greyColors[500],
      600: greyColors[600],
      dark: greyColors[700],
      800: greyColors[800],
      darker: greyColors[900],
      A100: greyColors[0],
      A200: greyColors.A400,
      A300: greyColors.A700,
      contrastText: greyColors[0]
    },
    error: {
      lighter: errorColors[0],
      light: errorColors[1],
      main: errorColors[2],
      dark: errorColors[3],
      darker: errorColors[4],
      contrastText
    },
    warning: {
      lighter: warningColors[0],
      light: warningColors[1],
      main: warningColors[2],
      dark: warningColors[3],
      darker: warningColors[4],
      contrastText: greyColors[100]
    },
    info: {
      lighter: infoColors[0],
      light: infoColors[1],
      main: infoColors[2],
      dark: infoColors[3],
      darker: infoColors[4],
      contrastText
    },
    success: {
      lighter: successColors[0],
      light: successColors[1],
      main: successColors[2],
      dark: successColors[3],
      darker: successColors[4],
      contrastText
    },
    grey: greyColors
  };
}
